var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_1192",
    "data-name": "Component 11 \\u2013 1192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "active-heart"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    clipPath: "url(#active-heart)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(0 0.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8277",
    "data-name": "Path 8277",
    d: "M22.037,19.019a6.5,6.5,0,0,0-9.612,0L12,19.472l-.424-.453A6.5,6.5,0,0,0,2.3,18.673q-.176.166-.341.345a7.523,7.523,0,0,0,0,10.135L11.379,39.21a.85.85,0,0,0,1.213.033l.033-.033,9.413-10.056A7.522,7.522,0,0,0,22.037,19.019Z",
    transform: "translate(0 -16.896)",
    fill: "#7e59d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHeart);
export default __webpack_public_path__ + "static/media/active-heart.33c8b1982fd48e9a0b245cd31ff72328.svg";
export { ForwardRef as ReactComponent };